import React, { Component } from "react";
import { AlertModal } from "../AlertModal/AlertModal";
import './ModalMensagemFinalizacao.css';

export const ModalMensagemFinalizacao =

class extends Component {
	render() {
    const solicitacao = this.props.solicitacao;
    const {nomeUsuario, nomeAtribuicaoUsuario, nomeOrgao, cnpjOrgaoFormatado, emailUsuario} = solicitacao;
		return <AlertModal
          titulo="Solicitação de cadastro concluída com sucesso"
		      visible={this.props.visible}
          handleClose={this.props.handleClose}
        >
          <div className="container-body">

            <p>Prezado {nomeUsuario}, {nomeAtribuicaoUsuario? nomeAtribuicaoUsuario: ''} do órgão {cnpjOrgaoFormatado} - {nomeOrgao}. </p>
            <p>Seu cadastro será avaliado pelo Gestor da Plataforma de Gestão do Conecta.</p>            
            <p>O resultado da avaliação será enviado para o email {emailUsuario}</p>

          </div>
        </AlertModal>
	}

}